<div *ngIf="isOpen" class="reports-modal-backdrop" (click)="close()"></div>

<div *ngIf="isOpen" class="reports-modal" role="dialog" aria-modal="true" aria-label="Referral Reports">
  <div class="reports-modal-header">
    <div>
      <h2>Referral Reports</h2>
      <p>Choose a report and its date, then generate it.</p>
    </div>
    <button class="x-btn" (click)="close()" type="button" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M6 6l12 12M18 6 6 18"/>
      </svg>
    </button>
  </div>

  <div class="reports-modal-body">
    <div class="picker-row">
      <div>
        <span class="lbl">Report</span>
        <div class="seg" role="radiogroup">
          <button type="button" [attr.aria-checked]="mode === 'daily'" (click)="setMode('daily')">Daily</button>
          <!-- Weekly reports temporarily disabled.Enable when weekly needed to be merged 
          <button type="button" [attr.aria-checked]="mode === 'weekly'" (click)="setMode('weekly')">Weekly</button>
          -->
        </div>
      </div>

      <div *ngIf="mode === 'daily'">
        <label class="lbl" for="reportDayDate">Report Date</label>
        <input
          id="reportDayDate"
          class="date-input"
          type="date"
          [(ngModel)]="dayDate"
          [max]="todayIso"
          (ngModelChange)="onFieldChange()"
        />
        <div class="quick">
          <button type="button" (click)="setQuickDay(1)">Yesterday</button>
          <button type="button" (click)="setQuickDay(0)">Today</button>
        </div>
      </div>

      <!-- Weekly reports temporarily disabled.
      <div *ngIf="mode === 'weekly'">
        <div class="pick-grid">
          <div>
            <label class="lbl" for="reportWkFrom">From Date</label>
            <input
              id="reportWkFrom"
              class="date-input"
              type="date"
              [(ngModel)]="wkFrom"
              [max]="todayIso"
              (ngModelChange)="onWkFromChange()"
            />
          </div>
          <div>
            <label class="lbl" for="reportWkTo">To Date</label>
            <input
              id="reportWkTo"
              class="date-input"
              type="date"
              [(ngModel)]="wkTo"
              [max]="todayIso"
              (ngModelChange)="onFieldChange()"
            />
          </div>
        </div>
        <div class="hint">Up to 7 days. Choosing a From date fills in the To date.</div>
        <div class="quick">
          <button type="button" (click)="setQuickWeek('last')">Last week</button>
          <button type="button" (click)="setQuickWeek('this')">This week</button>
        </div>
      </div>
      -->
    </div>

    <div class="error" role="alert">{{ errorMessage }}</div>
    <div class="selection-line" [innerHTML]="selectionLine || 'Select a valid date to continue.'"></div>

    <div *ngIf="loading" class="report-loading">Generating report…</div>

    <div *ngIf="!loading && mode === 'daily' && dailyReport as report" class="report">
      <div class="report-head">
        <h3>GBCS MSA Daily Referrals – {{ report.day }}</h3>
        <span class="meta">{{ reportCount }} referrals. Preview of {{ reportFileName }}</span>
      </div>

      <div class="sheet" role="tabpanel">
        <!-- Tab 0: GBCS MSA Daily Referrals -->
        <ng-container *ngIf="activeTab === 0">
          <table class="xl">
            <thead>
              <tr class="title"><td>Daily Referral Summary</td><td class="num">{{ report.day }}</td></tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of report.counts"><td>{{ c.label }}</td><td class="num">{{ c.count }}</td></tr>
              <tr class="total"><td>Total MSA/MCP Referrals</td><td class="num">{{ report.msaTotal }}</td></tr>
              <tr class="grand"><td>Total GB Daily Referrals Regardless of Vendor</td><td class="num">{{ report.grandTotal }}</td></tr>
            </tbody>
          </table>
          <div class="gap"></div>
          <table class="xl">
            <thead>
              <tr>
                <th>Date Requested</th>
                <th>Type of Referral</th>
                <th>Claim Name</th>
                <th>Claim Number</th>
                <th>Service Requested</th>
                <th class="wrap">Vendor Name if<br>"Other Vendor Referral"</th>
                <th class="wrap">Non-MSA/MCP Referral Service(s) Requested</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="report.rows.length === 0" class="empty-row"><td colspan="8">No referrals were requested on this date.</td></tr>
              <tr *ngFor="let x of report.rows">
                <td>{{ x.dateRequested }}</td>
                <td>{{ x.typeOfReferral }}</td>
                <td>{{ x.claimantName }}</td>
                <td>{{ x.claimNumber }}</td>
                <td>{{ x.serviceRequested }}</td>
                <td>{{ x.vendorName }}</td>
                <td class="wrap">{{ x.nonMsaServicesRequested }}</td>
                <td>{{ x.note }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>

      <div class="tabs" role="tablist" aria-label="Worksheets">
        <button
          *ngFor="let tab of tabs; let i = index"
          type="button"
          role="tab"
          [attr.aria-selected]="activeTab === i"
          (click)="activeTab = i"
        >
          {{ tab }}
        </button>
      </div>
    </div>

    <!-- Weekly reports temporarily disabled.
    <div *ngIf="!loading && mode === 'weekly' && weeklyReport as report" class="report">
      <div class="report-head">
        <h3>GBCS MSA Weekly Referrals – {{ report.from }} to {{ report.to }}</h3>
        <span class="meta">{{ report.rows.length }} referrals</span>
      </div>
      <div class="sheet">
        <table class="xl" style="width: 100%">
          <thead>
            <tr>
              <th>Claim #</th><th>Claimant Name</th><th>Service Type</th><th>Date Referred</th>
              <th class="wrap">Date Acknowledgement Sent to RM</th><th class="wrap">Date Service Initiated</th>
              <th class="wrap">Total Days to Acknowledge</th><th class="wrap">Total Days to Initiate</th>
              <th>Comments</th><th>SDID</th><th>Lien Service Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="report.rows.length === 0" class="empty-row"><td colspan="11">No referrals were received in this date range.</td></tr>
            <tr *ngFor="let x of report.rows">
              <td>{{ x.claimNumber }}</td><td>{{ x.claimantName }}</td><td>{{ x.serviceType }}</td><td>{{ x.dateReferred }}</td>
              <td>{{ x.dateAcknowledged }}</td><td>{{ x.dateInitiated }}</td>
              <td class="num">{{ x.daysToAcknowledge }}</td><td class="num">{{ x.daysToInitiate }}</td>
              <td>{{ x.comments }}</td><td>{{ x.sdid }}</td><td>{{ x.lienServiceType }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    -->
  </div>

  <div class="reports-modal-footer">
    <button type="button" class="pill outline" *ngIf="hasReport" [disabled]="downloading" (click)="download()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true" style="width: 15px; height: 15px; display: inline-block; vertical-align: -2px; margin-right: 6px;">
        <path d="M12 3v12m0 0-4-4m4 4 4-4M4 17v3h16v-3"/>
      </svg>
      {{ downloading ? 'Downloading…' : 'Download Excel' }}
    </button>
    <div class="right">
      <button type="button" class="pill outline" (click)="close()">Cancel</button>
      <button type="button" class="pill" [disabled]="loading" (click)="generate()">
        {{ loading ? 'Generating…' : 'Generate Report' }}
      </button>
    </div>
  </div>
</div>
